import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { get } from '../../services/api';
import { Shop, ArrowDown2 } from 'iconsax-react';
import { motion, AnimatePresence } from 'framer-motion';
import './BranchSwitcher.css';

const BranchSwitcher = () => {
    const { isOwner, selectedBranchId, setSelectedBranchId } = useAuth();
    const [branches, setBranches] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (isOwner) {
            fetchBranches();
        }
    }, [isOwner]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const fetchBranches = async () => {
        try {
            setLoading(true);
            const data = await get('/branches.php');
            setBranches(data || []);
        } catch (error) {
            console.error('Error fetching branches:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleBranchSelect = (branchId) => {
        setSelectedBranchId(branchId);
        setIsOpen(false);
    };

    if (!isOwner) return null;

    const currentBranch = branches.find(b => b.id.toString() === selectedBranchId.toString());
    const displayText = selectedBranchId === 'all' ? 'گشت لایەنەکان' : (currentBranch?.name || 'لایەن هەڵبژێرە');

    return (
        <div className="branch-switcher-container" ref={dropdownRef}>
            <div
                className={`branch-switcher-trigger ${isOpen ? 'active' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="branch-icon-wrapper">
                    <Shop size={18} variant="Bold" />
                </div>

                <div className="branch-info">
                    <span className="branch-label">لایەن</span>
                    <span className="branch-name-current">{displayText}</span>
                </div>

                <ArrowDown2 size={16} className="branch-arrow" />
            </div>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        className="branch-dropdown-menu backdrop-blur-lg"
                        initial={{ opacity: 0, y: -10, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: -10, scale: 0.95 }}
                        transition={{ duration: 0.2, ease: "easeOut" }}
                    >
                        <div
                            className={`branch-dropdown-item ${selectedBranchId === 'all' ? 'selected' : ''}`}
                            onClick={() => handleBranchSelect('all')}
                        >
                            <div className="item-dot" />
                            <span>گشت لایەنەکان</span>
                        </div>

                        {branches.map(branch => (
                            <div
                                key={branch.id}
                                className={`branch-dropdown-item ${selectedBranchId.toString() === branch.id.toString() ? 'selected' : ''}`}
                                onClick={() => handleBranchSelect(branch.id.toString())}
                            >
                                <div className="item-dot" />
                                <span>{branch.name}</span>
                            </div>
                        ))}

                        {loading && (
                            <div className="p-3 text-center">
                                <div className="w-5 h-5 border-2 border-primary-red/30 border-t-primary-red rounded-full animate-spin mx-auto" />
                            </div>
                        )}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default BranchSwitcher;
